<script setup lang="ts">
import { CoIcon } from '@deputy/copilot2';

const props = defineProps<{
  canEdit?: boolean;
  editModalList?: boolean;
  icon?: string;
  selectBreaksModal?: boolean;
  infoContent: boolean;
}>();

function getShiftItemClass() {
  if (props.editModalList) {
    return `edit-shift-detail-line-item`;
  } else if (props.selectBreaksModal) {
    return `select-break-shift-detail-line-item`;
  } else {
    return `shift-detail-line-item`;
  }
}

const emit = defineEmits<{
  (e: 'showEditModal'): void;
}>();
</script>

<template>
  <a @click="emit('showEditModal')" class="__edit-details" v-if="canEdit"
    ><div class="shift-detail-line-item">
      <CoIcon
        class="__details-icon"
        v-if="props.icon"
        :name="props.icon"
      ></CoIcon>
      <div v-if="!props.infoContent" class="__details-item-content">
        <slot name="main-content"></slot>
      </div>
      <div v-else>
        <div class="__details-item-main">
          <slot name="main-content"></slot>
        </div>
        <div class="__details-item-info">
          <slot name="info-content"></slot>
        </div>
      </div>
    </div>
    <CoIcon class="__edit-details-icon" name="pencil"
  /></a>
  <div v-else :class="getShiftItemClass()">
    <CoIcon v-if="props.icon" :name="props.icon"></CoIcon>
    <div class="__details-item" v-if="!props.infoContent">
      <slot name="main-content"></slot>
    </div>
    <div v-else>
      <div class="__details-item-main">
        <slot name="main-content"></slot>
      </div>
      <div class="__details-item-info">
        <slot name="info-content"></slot>
      </div>
    </div>
  </div>
</template>

<style scoped>
.shift-detail-line-item {
  margin: 14px 0 16px 13px;
  display: flex;
}
.shift-detail-line-item .__details-item {
  margin: -1px;
}
.select-break-shift-detail-line-item {
  margin-bottom: 0;
  display: flex;
}
.edit-shift-detail-line-item {
  margin-bottom: 0;
  display: flex;
  width: 100%;
}
.__details-item-content {
  margin-left: 3px;
}
.__details-item-main,
.__details-item {
  font-size: 16px;
  display: flex;
  align-items: center;
}
.__details-item-info {
  font-size: 15px;
  color: var(--co-text-secondary);
  margin-top: 8px;
}
.co-icon {
  color: #cccbd0;
  margin-right: 18.6px;
  width: 20px;
  height: 20px;
}
.__edit-details {
  display: flex;
}

.__details-icon {
  width: 20px;
  height: 20px;
}

.__edit-details-icon {
  margin-left: 13.5px;
  margin-right: 0;
  color: var(--co-shift-empty-border);
}

.__edit-details:hover .__edit-details-icon {
  color: var(--co-text-highlight-hover);
}
</style>

<style>
.break-details .shift-detail-line-item {
  margin: 0;
}
.__edit-details .shift-detail-line-item {
  margin: 0;
  padding: 8px 0;
}
.__edit-details .break-details .shift-detail-line-item {
  padding: 0;
}
</style>
